import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { compose } from "redux";

import { withStyles } from "@material-ui/core/styles";
import AppBar from "../LandingComponents/AppBar";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import CallMade from "@material-ui/icons/CallMade";
import MenuIcon from "@material-ui/icons/Menu";
import LandingNavigator from "./LandingNavigator";

// for login menu
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";

import Toolbar, { styles as toolbarStyles } from "../LandingComponents/Toolbar";
import Logo from "../../assets/Logo-cleaned.png";

import * as actions from "../../containers/Root/actions";

const styles = (theme) => ({
  LandingAppBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  title: {
    font: "500 25px Roboto,sans-serif",
    cursor: "pointer",
    color: "white",
    textDecoration: "none",
    marginRight: 20,
  },
  placeholder: toolbarStyles(theme).root,
  toolbar: {
    justifyContent: "space-between",
  },
  left: {
    flex: 1,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  logo: {
    height: 36,
    marginRight: 10,
  },
  leftLinkActive: {
    color: theme.palette.common.white,
  },
  right: {
    flex: 1,
    display: "flex",
    justifyContent: "flex-end",
  },
  rightLink: {
    color: theme.palette.common.white,
    display: "flex",
    font: "300 18px Roboto,sans-serif",
    gap: "2px",
    marginLeft: theme.spacing.unit * 5,
    textDecoration: "none",
    "&:hover": {
      color: theme.palette.secondary.main,
    },
  },
  rightLinkActive: {
    font: "300 18px Roboto,sans-serif",
    color: theme.palette.secondary.main,
    marginLeft: theme.spacing.unit * 5,
    textDecoration: "none",
  },
  linkSecondary: {
    color: theme.palette.secondary.main,
  },
  avatar: {
    margin: 10,
    color: "#fff",
    backgroundColor: theme.palette.secondary.main,
  },
  iconButtonAvatar: {
    padding: 4,
    marginLeft: theme.spacing.unit * 3,
    textDecoration: "none",
  },
  menuButton: {
    marginLeft: -theme.spacing.unit,
    marginRight: theme.spacing.unit * 2,
  },
});

class LandingNavBar extends React.Component {
  handleMenuOpen = (event) => {
    this.props.loginMenuOpen(event.currentTarget.id);
  };

  handleMenuClose = () => {
    this.props.loginMenuClose();
  };

  render() {
    const { classes, handleDrawerToggle, RootMobileOpen, location } =
      this.props;

    const links = (
      <Button>
        <a
          href="https://www.comp.nus.edu.sg/~dbsystem/"
          style={{
            fontSize: 16,
            color: "white",
            textDecoration: "none",
          }}
        >
          DB System
        </a>
      </Button>
    );

    const navLinks = [
      {
        url: "/demo-features",
        label: "Demo",
      },
      {
        url: "/publications",
        label: "Publications",
      },
      {
        url: "/docs/basic/get",
        label: "Docs",
      },
      {
        url: "",
        ext_url: "https://github.com/nusdbsystem/forkbase",
        label: "GitHub",
      },
      {
        url: "/contact",
        label: "Contact",
      },
    ];

    return (
      <div>
        <LandingNavigator
          PaperProps={{
            style: { width: 250, backgroundColor: "rgb(35, 47, 62)" },
          }}
          variant="temporary"
          open={RootMobileOpen}
          onClose={handleDrawerToggle}
        />
        <AppBar position="fixed" className={classes.LandingAppBar}>
          <Toolbar className={classes.toolbar}>
            <Hidden mdUp>
              <Grid item>
                <IconButton
                  color="inherit"
                  aria-label="Open drawer"
                  onClick={handleDrawerToggle}
                  className={classes.menuButton}
                >
                  <MenuIcon />
                </IconButton>
              </Grid>
            </Hidden>
            <div className={classes.left}>
              <Link to="/">
                <img alt="logo" src={Logo} className={classes.logo} />
              </Link>

              <Link to="/" className={classes.title}>
                {"ForkBase"}
              </Link>

              <Hidden smDown>
                {navLinks.map((link, index) => {
                  if (link.ext_url) {
                    return (
                      <a
                        href={link.ext_url}
                        rel={"noopener noreferrer"}
                        className={classes.rightLink}
                        target={"_blank"}
                      >
                        {link.label}

                        <CallMade fontSize={"small"} />
                      </a>
                    );
                  } else {
                    return (
                      <Link
                        key={index}
                        to={link.url}
                        className={
                          location.pathname === link.url
                            ? classes.rightLinkActive
                            : classes.rightLink
                        }
                      >
                        {link.label}
                      </Link>
                    );
                  }
                })}
              </Hidden>
            </div>
            {links}
          </Toolbar>
        </AppBar>
        <div className={classes.placeholder} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  anchorElId: state.Root.dropdownAnchorElId,
  isAuthenticated: state.Root.token !== null,
  // initials: state.firebaseReducer.profile.initials,
  // bgColor: state.firebaseReducer.profile.color
  RootMobileOpen: state.Root.RootMobileOpen,
});

const mapDispatchToProps = {
  loginMenuOpen: actions.loginMenuOpen,
  loginMenuClose: actions.loginMenuClose,
  handleDrawerToggle: actions.handleDrawerToggle,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withStyles(styles)
)(LandingNavBar);
